import { SKIP_RENDER } from '@mediashop/app/constants/semanticConstants';
import Icon from '@mediashop/base/pattern/atom/Icon';
import { ReactElement } from 'react';
import { BreadcrumbItemProps } from './index';

const componentName = 'breadcrumb-item';

const BreadcrumbItem = ({ children, showIcon = true }: BreadcrumbItemProps): ReactElement => {
    return (
        <div className={componentName}>
            {showIcon ? <Icon className={`${componentName}__icon`} name="ArrowRight" /> : SKIP_RENDER}
            {children}
        </div>
    );
};

export default BreadcrumbItem;
